import { useMutation } from '@tanstack/react-query'
import { AnimalController } from 'src/controllers/animal.controller'
import { UpdateAnimalImageDto } from 'src/dto/animal.dto'

const animalController = new AnimalController()

export function useUpdateAnimalImage(scope: string = 'updateAnimalImage') {
  return useMutation<any, Error, UpdateAnimalImageDto>({
    mutationKey: [scope],
    mutationFn: (UpdateAnimalImageDto: UpdateAnimalImageDto) => animalController.updateAnimalImage(UpdateAnimalImageDto)
  })
}
